import { render, staticRenderFns } from "./ShareProjectModal.vue?vue&type=template&id=8fb793d2&scoped=true"
import script from "./ShareProjectModal.vue?vue&type=script&lang=js"
export * from "./ShareProjectModal.vue?vue&type=script&lang=js"
import style0 from "./ShareProjectModal.vue?vue&type=style&index=0&id=8fb793d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fb793d2",
  null
  
)

export default component.exports